/******************************
 * Default pack for generic bootstrap template.
 * Smallest possible package, please!
******************************/
import './js/global.js';
import "./css/polmaker.scss";
